import { useState, useEffect } from "react";
import { PrimaryButton, SecondaryButton } from "../components/Buttons";
import { Link } from "react-router-dom";

const AddNewShop = () => {
    const [inputData, setInputData] = useState(null);
    const [fetchStatus, setFetchStatus] = useState('idle');

    const handleInputData = (event) => {
        const { id, value } = event.target;
        setInputData(prevInputData => ({
            ...prevInputData,
            [id]: value
        }))
    }

    const sendData = async () => {
        setFetchStatus('loading')
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/shops/add-new-shop`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(inputData)
            });
            if (response.ok) {
                const data = await response.json();
                setFetchStatus('succeeded');
            } else {
                throw new Error("Errore durante l'invio dei dati. Riprova.");
                setFetchStatus('error');
            }
        } catch (error) {
            console.error('Errore: ', error)
            setFetchStatus('error')
        }
    }

    const refreshPage = () => {
        window.location.replace(window.location.href);
    }

    return (
        <div className="main-container">
            <h1>Add new shop</h1>
            <div className="w-full rounded-xl border border-orange-500 shadow-xl overflow-hidden flex flex-col p-8 relative gap-2">
                {
                    (fetchStatus === 'idle' || fetchStatus === 'loading') ? (
                        <>
                            <label htmlFor="name">Shop name</label>
                            <input type="text" id="name" className="w-full" onChange={handleInputData} />
                            <label htmlFor="mainPhone">Phone</label>
                            <input type="text" id="mainPhone" className="w-full" onChange={handleInputData} />
                            <label htmlFor="website">Website</label>
                            <input type="text" id="website" className="w-full" onChange={handleInputData} />
                            <label htmlFor="city">City</label>
                            <input type="text" id="city" className="w-full" onChange={handleInputData} />
                            <label htmlFor="address">Address</label>
                            <input type="text" id="address" className="w-full" onChange={handleInputData} />
                            <label htmlFor="lat">Latitude</label>
                            <input type="text" id="lat" className="w-full" onChange={handleInputData} />
                            <label htmlFor="lng">Longitude</label>
                            <input type="text" id="lng" className="w-full" onChange={handleInputData} />
                            <label htmlFor="shopAvatar">Shop avatar</label>
                            <input type="text" id="shopAvatar" className="w-full" onChange={handleInputData} />
                            {
                                fetchStatus === 'idle' ? (
                                    <PrimaryButton text="Invia dati" click={sendData} />
                                ) : (
                                    fetchStatus === 'Loading' && <div class="custom-loader"></div>
                                )
                            }
                        </>
                    ) : (

                        fetchStatus === 'succeeded' ? (
                            <>
                                <h3>Nuova attività inserita con successo</h3>
                                <Link to="/"><PrimaryButton text="Torna alla home"/></Link>
                                <SecondaryButton text="Inserisci un altro shop" click={refreshPage}/>
                            </>
                        ) : (
                            fetchStatus === 'error' && <h3>Qualcosa è andato storto, ricarica la pagina e riprova</h3>
                        )
                    )
                }
            </div>
        </div >
    )
}

export default AddNewShop;